import { NavLink } from 'react-router-dom';
import { CounterBadge } from '@fluentui/react-components';
import {
  HomeRegular,
  DocumentBulletListRegular,
  PeopleRegular,
  CalendarRegular,
  MailRegular,
  MailInboxRegular,
  DocumentCheckmarkRegular,
  MoneyRegular,
  DocumentPdfRegular,
  CloudArrowUpRegular,
  DataBarVerticalRegular,
  ChatRegular,
  BuildingRegular,
  ContactCardRegular,
  SettingsRegular,
  ShieldPersonRegular,
  NoteRegular,
  StarRegular,
} from '@fluentui/react-icons';

const navItems = [
  { to: '/', icon: <HomeRegular />, label: 'Dashboard' },
  { to: '/tax-returns', icon: <DocumentBulletListRegular />, label: 'Tax Returns', badgeKey: 'taxReturns' as const },
  { to: '/tax-clients', icon: <ContactCardRegular />, label: 'Tax Clients' },
  { to: '/client-uploads', icon: <CloudArrowUpRegular />, label: 'Client Uploads' },
  { to: '/outreach', icon: <MailRegular />, label: 'Client Outreach' },
  { to: '/priority-outreach', icon: <StarRegular />, label: 'Priority Outreach' },
  { to: '/inquiries', icon: <ChatRegular />, label: 'Client Inquiries' },
  { to: '/irs-notices', icon: <MailInboxRegular />, label: 'IRS Notices' },
  { to: '/outreach-dashboard', icon: <DataBarVerticalRegular />, label: 'Outreach Analytics' },
  { to: '/drake', icon: <DocumentPdfRegular />, label: 'Drake Import' },
  { to: '/workload', icon: <PeopleRegular />, label: 'Preparer Workload' },
  { to: '/preparer-billing', icon: <MoneyRegular />, label: 'Preparer Billing' },
  { to: '/calendar', icon: <CalendarRegular />, label: 'Calendar' },
  { to: '/client-opt-outs', icon: <DocumentCheckmarkRegular />, label: 'Client Opt-Outs' },
  { to: '/inhouse-clients', icon: <BuildingRegular />, label: 'In-House Clients' },
  { to: '/staff-roles', icon: <ShieldPersonRegular />, label: 'Staff Roles' },
  { to: '/patch-notes', icon: <NoteRegular />, label: 'Patch Notes' },
  { to: '/settings', icon: <SettingsRegular />, label: 'Settings' },
];

interface NavMenuProps {
  unassignedDropoffs?: number;
}

export default function NavMenu({ unassignedDropoffs = 0 }: NavMenuProps) {
  return (
    <nav className="app-nav">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => isActive ? 'active' : ''}
          end={item.to === '/'}
        >
          {item.icon}
          {item.label}
          {item.badgeKey === 'taxReturns' && unassignedDropoffs > 0 && (
            <CounterBadge
              count={unassignedDropoffs}
              color="danger"
              size="small"
              style={{ marginLeft: 'auto' }}
            />
          )}
        </NavLink>
      ))}
    </nav>
  );
}
